import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _073d9dc6 = () => interopDefault(import('..\\pages\\login.vue' /* webpackChunkName: "pages/login" */))
const _186e5c48 = () => interopDefault(import('..\\pages\\customer\\client.vue' /* webpackChunkName: "pages/customer/client" */))
const _731fdc8a = () => interopDefault(import('..\\pages\\customer\\layout.vue' /* webpackChunkName: "pages/customer/layout" */))
const _c87b5266 = () => interopDefault(import('..\\pages\\customer\\order.vue' /* webpackChunkName: "pages/customer/order" */))
const _4692e664 = () => interopDefault(import('..\\pages\\customer\\orderadd.vue' /* webpackChunkName: "pages/customer/orderadd" */))
const _76ed40c0 = () => interopDefault(import('..\\pages\\error\\401.vue' /* webpackChunkName: "pages/error/401" */))
const _7698b3ba = () => interopDefault(import('..\\pages\\error\\404.vue' /* webpackChunkName: "pages/error/404" */))
const _231fcf43 = () => interopDefault(import('..\\pages\\mendian\\list.vue' /* webpackChunkName: "pages/mendian/list" */))
const _60e525a2 = () => interopDefault(import('..\\pages\\resource\\folder.vue' /* webpackChunkName: "pages/resource/folder" */))
const _9932e0fe = () => interopDefault(import('..\\pages\\system\\menu.vue' /* webpackChunkName: "pages/system/menu" */))
const _7100d1d0 = () => interopDefault(import('..\\pages\\system\\role.vue' /* webpackChunkName: "pages/system/role" */))
const _70fd6026 = () => interopDefault(import('..\\pages\\system\\user.vue' /* webpackChunkName: "pages/system/user" */))
const _1cf57460 = () => interopDefault(import('..\\pages\\components\\common\\checkFile.vue' /* webpackChunkName: "pages/components/common/checkFile" */))
const _4349aeb8 = () => interopDefault(import('..\\pages\\components\\common\\editIndex.vue' /* webpackChunkName: "pages/components/common/editIndex" */))
const _1303cb2f = () => interopDefault(import('..\\pages\\components\\customer\\clientFileUpload.vue' /* webpackChunkName: "pages/components/customer/clientFileUpload" */))
const _2996619c = () => interopDefault(import('..\\pages\\components\\customer\\editClient.vue' /* webpackChunkName: "pages/components/customer/editClient" */))
const _28bfcad6 = () => interopDefault(import('..\\pages\\components\\customer\\info.vue' /* webpackChunkName: "pages/components/customer/info" */))
const _42370866 = () => interopDefault(import('..\\pages\\components\\customer\\inputClientSearch.vue' /* webpackChunkName: "pages/components/customer/inputClientSearch" */))
const _6b424e50 = () => interopDefault(import('..\\pages\\components\\customer\\inputImgChange.vue' /* webpackChunkName: "pages/components/customer/inputImgChange" */))
const _80083770 = () => interopDefault(import('..\\pages\\components\\customer\\inputImgSearch.vue' /* webpackChunkName: "pages/components/customer/inputImgSearch" */))
const _58ab091d = () => interopDefault(import('..\\pages\\components\\customer\\inputImgShow.vue' /* webpackChunkName: "pages/components/customer/inputImgShow" */))
const _0808bb51 = () => interopDefault(import('..\\pages\\components\\customer\\layout.vue' /* webpackChunkName: "pages/components/customer/layout" */))
const _3ce1e09d = () => interopDefault(import('..\\pages\\components\\customer\\picconfirm.vue' /* webpackChunkName: "pages/components/customer/picconfirm" */))
const _09fc9798 = () => interopDefault(import('..\\pages\\components\\customer\\picupload.vue' /* webpackChunkName: "pages/components/customer/picupload" */))
const _6b8cad06 = () => interopDefault(import('..\\pages\\components\\mendian\\info.vue' /* webpackChunkName: "pages/components/mendian/info" */))
const _72a385ac = () => interopDefault(import('..\\pages\\components\\mendian\\mendianBreadcrumb.vue' /* webpackChunkName: "pages/components/mendian/mendianBreadcrumb" */))
const _b88675b0 = () => interopDefault(import('..\\pages\\components\\resource\\folderBreadcrumb.vue' /* webpackChunkName: "pages/components/resource/folderBreadcrumb" */))
const _3c7f42f0 = () => interopDefault(import('..\\pages\\components\\resource\\historyVersions.vue' /* webpackChunkName: "pages/components/resource/historyVersions" */))
const _cb462978 = () => interopDefault(import('..\\pages\\components\\resource\\imgDownLoad.vue' /* webpackChunkName: "pages/components/resource/imgDownLoad" */))
const _625bc0a0 = () => interopDefault(import('..\\pages\\components\\resource\\picMark.vue' /* webpackChunkName: "pages/components/resource/picMark" */))
const _d05cacc6 = () => interopDefault(import('..\\pages\\components\\resource\\picType.vue' /* webpackChunkName: "pages/components/resource/picType" */))
const _1ec9bb18 = () => interopDefault(import('..\\pages\\components\\resource\\uploadFile.vue' /* webpackChunkName: "pages/components/resource/uploadFile" */))
const _dbd6677e = () => interopDefault(import('..\\pages\\components\\system\\editMenu.vue' /* webpackChunkName: "pages/components/system/editMenu" */))
const _b3a45850 = () => interopDefault(import('..\\pages\\components\\system\\editRole.vue' /* webpackChunkName: "pages/components/system/editRole" */))
const _b3a0e6a6 = () => interopDefault(import('..\\pages\\components\\system\\editUser.vue' /* webpackChunkName: "pages/components/system/editUser" */))
const _3d95faaf = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/login",
    component: _073d9dc6,
    name: "login"
  }, {
    path: "/customer/client",
    component: _186e5c48,
    name: "customer-client"
  }, {
    path: "/customer/layout",
    component: _731fdc8a,
    name: "customer-layout"
  }, {
    path: "/customer/order",
    component: _c87b5266,
    name: "customer-order"
  }, {
    path: "/customer/orderadd",
    component: _4692e664,
    name: "customer-orderadd"
  }, {
    path: "/error/401",
    component: _76ed40c0,
    name: "error-401"
  }, {
    path: "/error/404",
    component: _7698b3ba,
    name: "error-404"
  }, {
    path: "/mendian/list",
    component: _231fcf43,
    name: "mendian-list"
  }, {
    path: "/resource/folder",
    component: _60e525a2,
    name: "resource-folder"
  }, {
    path: "/system/menu",
    component: _9932e0fe,
    name: "system-menu"
  }, {
    path: "/system/role",
    component: _7100d1d0,
    name: "system-role"
  }, {
    path: "/system/user",
    component: _70fd6026,
    name: "system-user"
  }, {
    path: "/components/common/checkFile",
    component: _1cf57460,
    name: "components-common-checkFile"
  }, {
    path: "/components/common/editIndex",
    component: _4349aeb8,
    name: "components-common-editIndex"
  }, {
    path: "/components/customer/clientFileUpload",
    component: _1303cb2f,
    name: "components-customer-clientFileUpload"
  }, {
    path: "/components/customer/editClient",
    component: _2996619c,
    name: "components-customer-editClient"
  }, {
    path: "/components/customer/info",
    component: _28bfcad6,
    name: "components-customer-info"
  }, {
    path: "/components/customer/inputClientSearch",
    component: _42370866,
    name: "components-customer-inputClientSearch"
  }, {
    path: "/components/customer/inputImgChange",
    component: _6b424e50,
    name: "components-customer-inputImgChange"
  }, {
    path: "/components/customer/inputImgSearch",
    component: _80083770,
    name: "components-customer-inputImgSearch"
  }, {
    path: "/components/customer/inputImgShow",
    component: _58ab091d,
    name: "components-customer-inputImgShow"
  }, {
    path: "/components/customer/layout",
    component: _0808bb51,
    name: "components-customer-layout"
  }, {
    path: "/components/customer/picconfirm",
    component: _3ce1e09d,
    name: "components-customer-picconfirm"
  }, {
    path: "/components/customer/picupload",
    component: _09fc9798,
    name: "components-customer-picupload"
  }, {
    path: "/components/mendian/info",
    component: _6b8cad06,
    name: "components-mendian-info"
  }, {
    path: "/components/mendian/mendianBreadcrumb",
    component: _72a385ac,
    name: "components-mendian-mendianBreadcrumb"
  }, {
    path: "/components/resource/folderBreadcrumb",
    component: _b88675b0,
    name: "components-resource-folderBreadcrumb"
  }, {
    path: "/components/resource/historyVersions",
    component: _3c7f42f0,
    name: "components-resource-historyVersions"
  }, {
    path: "/components/resource/imgDownLoad",
    component: _cb462978,
    name: "components-resource-imgDownLoad"
  }, {
    path: "/components/resource/picMark",
    component: _625bc0a0,
    name: "components-resource-picMark"
  }, {
    path: "/components/resource/picType",
    component: _d05cacc6,
    name: "components-resource-picType"
  }, {
    path: "/components/resource/uploadFile",
    component: _1ec9bb18,
    name: "components-resource-uploadFile"
  }, {
    path: "/components/system/editMenu",
    component: _dbd6677e,
    name: "components-system-editMenu"
  }, {
    path: "/components/system/editRole",
    component: _b3a45850,
    name: "components-system-editRole"
  }, {
    path: "/components/system/editUser",
    component: _b3a0e6a6,
    name: "components-system-editUser"
  }, {
    path: "/",
    component: _3d95faaf,
    name: "index"
  }, {
    path: "*",
    component: _7698b3ba
  }, {
    path: "/404",
    component: _7698b3ba
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
